import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';


export const StyledFloater = styled.span`
  display: inline-block;

  & span {
    display: inline-block;
  }
`;

export const TooltipBaloon = styled.div`
  max-width: 90vw;
  display: flex;
  align-items: center;
  padding: 20px;
  background: #ffff;
  color: ${ColorPalette.HEX.CharlestonGreen};
  border-radius: 12px;
`;


export const Content = styled.div`
  flex: 1;
  font-size: 14px;
  font-weight: normal;
  color: ${ColorPalette.HEX.White};
`;
